import Env from '@/common/constants/Env.json';
import EnvStage from '@/common/constants/Env_stage.json';
import EnvProd from '@/common/constants/Env_prod.json';
// import EnvDevdocker from '@/common/constants/Env_devdocker.json'
import Util from '@/common/utils/Util';
import queryString from 'query-string';
import store from '@/store';

let CODE_ENV_LIST = Env;

if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = EnvProd;
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage;
}
// else if (process.env.VUE_APP_MODE === 'devdocker') {
// CODE_ENV_LIST = EnvDevdocker
// }

export const ACCESS_TOKEN_NAME = 'authorization';
export const REFRESH_TOKEN_NAME = 'refresh_token';

const CODE_GENDER = {
  1: '남',
  0: '여'
};

const CODE_TERMS_TYPE = {
  PRIVACY: {
    value: 31,
    name: '개인정보처리방침'
  },
  USE: {
    value: 32,
    name: '서비스 이용약관'
  },
  PRIVACY_USE: {
    value: 33,
    name: '개인정보수집이용동의'
  },
  PRIVACY_THIRD: {
    value: 34,
    name: '개인정보 제3자 제공 동의'
  },
  MARKETING: {
    value: 35,
    name: '마케팅활용동의'
  },
  PAY_SERVICE: {
    value: 'PAY_SERVICE',
    name: '유료서비스 이용 및 결제'
  },
  WITHDRAW: {
    value: 50,
    name: '회원 탈퇴약관'
  }
};

const CODE_MATCHING_STATUS = {
  ON: {
    name: '신청 중',
    value: 1
  },
  CANCEL: {
    name: '신청 취소',
    value: 2
  },
  COMPLETE: {
    name: '매칭 완료',
    value: 3
  },
  DELETE: {
    name: '삭제',
    value: 4
  }
};

const CODE_MATCHING_TYPE = {
  SPECIFY_RQST: {
    name: '지정 신청',
    value: 1
  },
  CNSLT_ASSIGNMENT: {
    name: '상담 배정',
    value: 2
  },
  INPUT_BY_CUSTOMER: {
    name: '고객 입력',
    value: 3
  },
  OFFLINE: {
    name: '임의 입력',
    value: 4
  }
};

const CONSULT_TEXT_LIST = [
  '가지고 있는 보험을 전체적으로 점검 받고 싶습니다.',
  '보험료가 부담되어 줄이고 싶은데 어떻게 조정해야 할 지 모르겠습니다.',
  '부족한 보험은 무엇인지, 과도하게 들어있는 보험은 무엇인지 알고 싶습니다.',
  '저축도 늘리고 노후준비도 잘 할 수 있는 방법을 알고 싶습니다.',
  '가족을 위해서 준비할 수 있는 보험을 상담 받고 싶습니다.',
  '암, 뇌혈관, 힘혈관 등 3대 진단금을 보강하고 싶습니다.',
  '실손의료비보험이 아직 없습니다. 어떻게 준비하면 좋을까요?',
  '고혈압, 당뇨 등 만성질환이 있는데 가입할 수 있는 보험이 있을까요?',
  '상속과 증여를 위한 보험 플랜을 상담 받고 싶습니다. '
];

const CONSULT_TEXT_LABEL = {
  CLAIM: '보험금청구 지원서비스 신청합니다.',
  MISSED_CLAIM: '내가 몰라서 못받은 보험금을 알고싶어요',
  INSURANCE_CHECKUP: CONSULT_TEXT_LIST[0],
  INSURANCE_FEE_ADJUST: CONSULT_TEXT_LIST[1],
  INSURANCE_COVERAGE_REVIEW: CONSULT_TEXT_LIST[2],
  SAVING_AND_RETIREMENT: CONSULT_TEXT_LIST[3],
  FAMILY_INSURANCE_PLAN: CONSULT_TEXT_LIST[4],
  THREE_MAJOR_DIAGNOSIS: CONSULT_TEXT_LIST[5],
  MEDICAL_EXPENSE_INSURANCE: CONSULT_TEXT_LIST[6],
  CHRONIC_DISEASE_INSURANCE: CONSULT_TEXT_LIST[7],
  INHERITANCE_GIFT_PLAN: CONSULT_TEXT_LIST[8],
  INDUSTRIAL_ACCIDENT_LABOR: '산업재해와 관련해서 공인노무사의 상담을 받고 싶습니다.'
};

const getConsultTextLabel = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const key = String(value);
  if (/^\d+$/.test(key)) {
    return CONSULT_TEXT_LIST[Number(key)] || '';
  }
  return CONSULT_TEXT_LABEL[key] || key;
};

const getConsultTextLabels = (consultText) => {
  if (!consultText) return [];
  return consultText
    .split(',')
    .map((item) => getConsultTextLabel(item.trim()))
    .filter(Boolean);
};

const getMissedClaimChecklistLabels = (checklist) => {
  function toList(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object') return [value];
    if (typeof value !== 'string') return [];

    const trimmedValue = value.trim();
    if (!trimmedValue) return [];

    try {
      return toList(JSON.parse(trimmedValue));
    } catch (e) {
      return [];
    }
  }

  function toLabel(item) {
    if (!item) return '';
    if (typeof item === 'string') return item.replace(/<br\s*\/?>/gi, ' ');

    const text = item.text || item.label || item.name || '';
    if (!text) return '';

    return `${item.category ? `[${item.category}] ` : ''}${String(text).replace(/<br\s*\/?>/gi, ' ')}`;
  }

  return toList(checklist).map(toLabel).filter(Boolean);
};

const CODE_TICKET_TYPE = {
  CONSULTANT: {
    name: '컨설턴트',
    value: 'CONSULTANT'
  },
  CLUB: {
    name: '클럽',
    value: 2
  }
};
const CODE_TICKET_SUB_TYPE = {
  PRE: {
    name: '무료 이용권',
    value: 1
  },
  CONSULTANT: {
    name: '컨설턴트',
    value: 2
  },
  FIRST: {
    name: '퍼스트',
    value: 3
  },
  BUSINESS: {
    name: '비즈니스',
    value: 4
  },
  ECONOMY: {
    name: '이코노미',
    value: 5
  }
};

const CODE_TICKET_STATUS = {
  USING: {
    name: '이용 중',
    value: 1
  },
  EXPIRED: {
    name: '만료',
    value: 0
  },
  WAITING: {
    name: '사용대기',
    value: 2
  },
  CANCELED: {
    name: '취소',
    value: 3
  }
};

const CODE_CNST_CONTACT_TIME_TYPE = {
  MORNING: {
    value: 1,
    name: '오전'
  },
  AFTERNOON: {
    value: 2,
    name: '오후'
  },
  EVENING: {
    value: 3,
    name: '저녁'
  }
};

const CODE_CNST_TARGET_TYPE = {
  SELF: {
    value: 1,
    name: '본인'
  },
  FAMILY: {
    value: 2,
    name: '가족'
  }
};

const CODE_PDF_OUT_TYPE = {
  BEFORE: {
    value: 1,
    name: '보장 분석 전'
  },
  AFTER: {
    value: 2,
    name: '보장 분석 후'
  }
};

const labelTermsType = (val) => {
  if (val === CODE_TERMS_TYPE.USE.value) {
    return CODE_TERMS_TYPE.USE.name;
  } else if (val === CODE_TERMS_TYPE.PRIVACY.value) {
    return CODE_TERMS_TYPE.PRIVACY.name;
  } else if (val === CODE_TERMS_TYPE.PRIVACY_USE.value) {
    return CODE_TERMS_TYPE.PRIVACY_USE.name;
  } else if (val === CODE_TERMS_TYPE.PRIVACY_THIRD.value) {
    return CODE_TERMS_TYPE.PRIVACY_THIRD.name;
  } else if (val === CODE_TERMS_TYPE.MARKETING.value) {
    return CODE_TERMS_TYPE.MARKETING.name;
  } else if (val === CODE_TERMS_TYPE.PAY_SERVICE.value) {
    return CODE_TERMS_TYPE.PAY_SERVICE.name;
  } else if (val === CODE_TERMS_TYPE.WITHDRAW.value) {
    return CODE_TERMS_TYPE.WITHDRAW.name;
  }
  return '';
};

const labelTicketStatus = (val) => {
  if (val === CODE_TICKET_STATUS.USING.value) {
    return CODE_TICKET_STATUS.USING.name;
  } else if (val === CODE_TICKET_STATUS.EXPIRED.value) {
    return CODE_TICKET_STATUS.EXPIRED.name;
  } else if (val === CODE_TICKET_STATUS.WAITING.value) {
    return CODE_TICKET_STATUS.WAITING.name;
  } else if (val === CODE_TICKET_STATUS.CANCELED.value) {
    return CODE_TICKET_STATUS.CANCELED.name;
  }
  return '';
};

const labelTicketSubType = (val) => {
  if (val === CODE_TICKET_SUB_TYPE.PRE.value) {
    return CODE_TICKET_SUB_TYPE.PRE.name;
  } else if (val === CODE_TICKET_SUB_TYPE.CONSULTANT.value) {
    return CODE_TICKET_SUB_TYPE.CONSULTANT.name;
  } else if (val === CODE_TICKET_SUB_TYPE.FIRST.value) {
    return CODE_TICKET_SUB_TYPE.FIRST.name;
  } else if (val === CODE_TICKET_SUB_TYPE.BUSINESS.value) {
    return CODE_TICKET_SUB_TYPE.BUSINESS.name;
  } else if (val === CODE_TICKET_SUB_TYPE.ECONOMY.value) {
    return CODE_TICKET_SUB_TYPE.ECONOMY.name;
  }
  return '';
};

const labelMatchingStatus = (val) => {
  if (val === CODE_MATCHING_STATUS.ON.value) {
    return CODE_MATCHING_STATUS.ON.name;
  } else if (val === CODE_MATCHING_STATUS.CANCEL.value) {
    return CODE_MATCHING_STATUS.CANCEL.name;
  } else if (val === CODE_MATCHING_STATUS.COMPLETE.value) {
    return CODE_MATCHING_STATUS.COMPLETE.name;
  } else if (val === CODE_MATCHING_STATUS.DELETE.value) {
    return CODE_MATCHING_STATUS.DELETE.name;
  }
  return '';
};

const labelMatchingType = (val) => {
  if (val === CODE_MATCHING_TYPE.SPECIFY_RQST.value) {
    return CODE_MATCHING_TYPE.SPECIFY_RQST.name;
  } else if (val === CODE_MATCHING_TYPE.CNSLT_ASSIGNMENT.value) {
    return CODE_MATCHING_TYPE.CNSLT_ASSIGNMENT.name;
  } else if (val === CODE_MATCHING_TYPE.INPUT_BY_CUSTOMER.value) {
    return CODE_MATCHING_TYPE.INPUT_BY_CUSTOMER.name;
  } else if (val === CODE_MATCHING_TYPE.OFFLINE.value) {
    return CODE_MATCHING_TYPE.OFFLINE.name;
  }
  return '';
};

const labelCnstContactTimeType = (val) => {
  if (val === CODE_CNST_CONTACT_TIME_TYPE.MORNING.value) {
    return CODE_CNST_CONTACT_TIME_TYPE.MORNING.name;
  } else if (val === CODE_CNST_CONTACT_TIME_TYPE.AFTERNOON.value) {
    return CODE_CNST_CONTACT_TIME_TYPE.AFTERNOON.name;
  } else if (val === CODE_CNST_CONTACT_TIME_TYPE.EVENING.value) {
    return CODE_CNST_CONTACT_TIME_TYPE.EVENING.name;
  }
  return '';
};

const labelCnstTargetType = (val) => {
  if (val === CODE_CNST_TARGET_TYPE.SELF.value) {
    return CODE_CNST_TARGET_TYPE.SELF.name;
  } else if (val === CODE_CNST_TARGET_TYPE.FAMILY.value) {
    return CODE_CNST_TARGET_TYPE.FAMILY.name;
  }
  return '';
};

const CODE_PAY_STATUS = {
  TEMP: { name: '결제전', value: 0 },
  DONE: { name: '결제완료', value: 1 },
  FAIL: { name: '결제실패', value: 2 },
  CANCEL: { name: '결제취소', value: 3 }
};

const ConstCode = function () {
  return {
    CODE_ENV_LIST,
    CODE_GENDER,
    CODE_TICKET_STATUS,
    CODE_TICKET_TYPE,
    CODE_TICKET_SUB_TYPE,
    CODE_MATCHING_STATUS,
    CODE_MATCHING_TYPE,
    CONSULT_TEXT_LIST,
    CONSULT_TEXT_LABEL,
    CODE_TERMS_TYPE,
    CODE_PAY_STATUS,
    CODE_CNST_CONTACT_TIME_TYPE,
    CODE_CNST_TARGET_TYPE,
    CODE_PDF_OUT_TYPE,
    labelTicketStatus,
    labelTicketSubType,
    labelMatchingStatus,
    labelMatchingType,
    getConsultTextLabel,
    getConsultTextLabels,
    getMissedClaimChecklistLabels,
    labelTermsType,
    labelCnstContactTimeType,
    labelCnstTargetType,
    getImagePath: function (path = '') {
      if (Util.isEmpty(path)) return '';
      return `${this.CODE_ENV_LIST.FILE_SERVER_URL}files/origin/${path}`;
    },
    fnImageExpanding: function (path = '') {
      if (Util.isEmpty(path)) return false;
      window.open(`${this.CODE_ENV_LIST.FILE_SERVER_URL}${path}`, '_blank');
    },
    getIdentityVerification: function (callBackFunction = {}, callBackFunctionName = '', isWindow = 1, userType = 2) {
      cleanupIdentityVerification();
      vmFunction = callBackFunction;
      vmFunctionName = callBackFunctionName;
      windowObj = window.open('about:blank', '_blank', 'width=500,height=900');
      if (!windowObj) {
        cleanupIdentityVerification();
        alert('본인인증 팝업을 허용한 뒤 다시 시도해주세요.');
        return;
      }
      const params = { callBackFunction: callBackFunctionName, isWindow, userType };
      const relayAllowed = new Set([
        'https://bankdiary.co.kr',
        'https://bankdiary-expert-web.appgdev.co.kr',
        'http://localhost:5050'
      ]).has(window.location.origin);
      if (relayAllowed && window.BroadcastChannel && window.crypto?.randomUUID) {
        try {
          identityRequestId = window.crypto.randomUUID();
          const channel = new window.BroadcastChannel('bankdiary:nice:' + identityRequestId);
          identityResultChannel = channel;
          channel.onmessage = ({ data }) => {
            if (identityResultChannel === channel && data?.resultChannel === identityRequestId) {
              completeIdentityVerification(data);
            }
          };
          params.resultChannel = identityRequestId;
          params.resultOrigin = window.location.origin;
        } catch (error) {
          identityRequestId = null;
          console.warn('본인인증 중계 채널을 사용할 수 없습니다.');
        }
      }
      windowObj.location = this.CODE_ENV_LIST.AUTH_REQ_URL + '?' + queryString.stringify(params);
    },
    getPayRequest: function (params, callBackFunction = () => {}, callBackFunctionName = '') {
      console.log(params);
      vmPayFunction = callBackFunction;
      vmPayFunctionName = callBackFunctionName;
      payWindowObj = window.open(
        `${this.CODE_ENV_LIST.PAYMENT_REQ_URL}/api/payment/gateway?${queryString.stringify(params)}`,
        'tar_opener',
        'width=1200,height=800'
      );
      if (payWindowObj) {
        payWindowObj.focus();
      }
    }
  };
};

// 본인인증
let windowObj;
let vmFunction;
let vmFunctionName;
let identityResultChannel;
let identityRequestId;

function cleanupIdentityVerification() {
  vmFunction = null;
  vmFunctionName = null;
  identityRequestId = null;
  identityResultChannel?.close();
  identityResultChannel = null;
  if (windowObj && !windowObj.closed) windowObj.close();
  windowObj = null;
}

function completeIdentityVerification(data) {
  if (!data || data.source !== vmFunctionName || typeof vmFunction !== 'function') return;
  const callback = vmFunction;
  cleanupIdentityVerification();
  callback(data.params);
}

// 결제 관련
let vmPayFunction;
let vmPayFunctionName;
let payWindowObj;

function closePayWindow(afterClose = () => {}) {
  const target = payWindowObj;
  payWindowObj = null;
  let isAfterCloseCalled = false;
  let checkClosedTimer;

  const clearCheckClosedTimer = () => {
    if (checkClosedTimer) {
      clearInterval(checkClosedTimer);
    }
  };

  const runAfterClose = (delay = 500) => {
    if (isAfterCloseCalled) return;
    isAfterCloseCalled = true;
    clearCheckClosedTimer();
    setTimeout(afterClose, delay);
  };

  if (!target) {
    runAfterClose(0);
    return;
  }

  const tryClose = () => {
    try {
      if (!target.closed) {
        target.close();
      }
    } catch (e) {
      // ignore
    }

    if (target.closed) {
      runAfterClose();
    }
  };

  checkClosedTimer = setInterval(() => {
    try {
      if (target.closed) {
        clearInterval(checkClosedTimer);
        runAfterClose();
      }
    } catch (e) {
      clearInterval(checkClosedTimer);
      runAfterClose();
    }
  }, 100);

  tryClose();
  [100, 300, 800].forEach((delay) => {
    setTimeout(tryClose, delay);
  });
}

window.addEventListener('message', function ({ data, origin, source }) {
  if (!data || typeof data !== 'object') return;
  if (!Util.isEmpty(data.source) && data.source === vmFunctionName) {
    if (origin !== new URL(CODE_ENV_LIST.AUTH_REQ_URL).origin || source !== windowObj) return;
    if (data.resultChannel && data.resultChannel !== identityRequestId) return;
    completeIdentityVerification(data);
  } else if (!Util.isEmpty(data.source) && data.source === 'endedSavePdf') {
    // pdf 생성 완료
    store.commit('layout/setIsLoading', { isLoading: false });
  } else if (!Util.isEmpty(data.source) && data.source === vmPayFunctionName) {
    // 결제 콜백 message 처리
    closePayWindow(() => {
      vmPayFunction(data.params);
    });
  }
});

export default ConstCode();
